<template>
	<div style="margin: 10px;" v-loading="loading">
		<el-row>
			<el-col :spa="24">
				<el-card class="box-card">
					<h4 class="title">参数信息</h4>
					<el-form ref="form" :model="form" label-width="120px" :rules="rules">
						<el-form-item label="图片" prop="pic">
							<!-- <el-input readonly v-model="form.pic" style="width:20%;float: left;" readonly></el-input> -->
							<el-upload drag  list-type="picture-card"  action="" multiple :limit="1" :on-success="getLogo" :file-list="logoList"
							 :on-remove="RemoveLogo" :on-exceed="handleLogo" :before-upload="beforePic" style="width:auto;float: left;">
								<i class="el-icon-picture-outline"></i>
								<br />
								<span class="uploadTip">将图片拖到此处，或点击上传</span>
							</el-upload>
							<input type="button" size="mini" class="bullet" style="display: inline-block;float: left;" @click.stop="dialogVisible = true"
							 value="素材库选择">
							<!-- <img :src="settings.apiBaseImg+form.pic" alt="" v-if="form.pic"  style="width: 200px;height: 200px;margin-top: 10px;"> -->
						</el-form-item>
						<el-form-item label="栏目" prop="column">
							<el-input v-model="form.column" style="width: 30%;" placeholder="添加栏目名称" @click.native="getColumn" readonly></el-input>
						</el-form-item>
						<el-form-item label="名称" prop="name">
							<el-input v-model="form.name" style="width:30%"></el-input>
						</el-form-item>
						<el-form-item label="副标题" >
							<el-input v-model="form.subtitle" style="width:30%"></el-input>
						</el-form-item>
						<el-form-item label="简介" >
							<el-input type="textarea" v-model="form.desc" style="width:30%" rows="3"></el-input>
						</el-form-item>
						<el-form-item label="链接">
							<el-input  v-model="form.link" style="width:30%" ></el-input>
						</el-form-item>
						<el-form-item>
							<input type="button" @click="onSubmit('form')" class="submit" value="提交">
						</el-form-item>
					</el-form>
				</el-card>
			</el-col>
		</el-row>
		<!-- 素材库选择 -->
		<el-dialog title="素材库选择" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
			<files @selectPic="selectPic"></files>
		</el-dialog>
		<el-dialog title="栏目选择" :visible.sync="dialogColumnVisible" width="50%" :before-close="handleClose">
			<span class="select">您已选择:{{form.column}}</span>
			<el-tree :data="data" show-checkbox node-key="id" :props="defaultProps" :default-checked-keys="selectCId" ref="tree"
			 @check="handleNodeClick">
			</el-tree>
		</el-dialog>
	</div>
</template>

<script>
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
	import files from '../../../components/picFile.vue'
	export default {
		components: {
			files
		},
		data() {
			return {
				form: {
					//名称
					name: '',
					//链接
					link: '',
					//栏目
					column: [],
					pic: '',
					picThumb: '',
					id: '',
					subtitle:'',
					desc:''
				},
				rules: {
					pic: [{
						required: true,
						message: '请输入图片',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
					column: [{
						required: true,
						message: '请输入栏目',
						trigger: 'blur'
					}],
				},
				dialogVisible: false,
				logoList: [],
				tableData: [],
				currentPage: 1,
				pageSize: 5,
				total: 0,
				loading: false,
				data: [],
				dialogColumnVisible: false,
				defaultProps: {
					children: 'childRpColum',
					label: 'columname'
				},
				loading: false,
				selectCId: []

			}
		},
		created() {
			if (this.$route.query.iden == 'update') {
				var list = JSON.stringify(this.$route.query.rows)
				this.form.column = this.$route.query.rows.columns
				this.form.name = this.$route.query.rows.title
				this.form.link = this.$route.query.rows.website
				this.form.pic = this.$route.query.rows.images
				this.selectCId = this.$route.query.rows.column.split(',')
				this.form.id = this.$route.query.rows.id
				this.form.desc = this.$route.query.rows.description
				this.form.subtitle = this.$route.query.rows.subtitle
				this.logoList.push({url:this.settings.apiBaseImg+this.$route.query.rows.images})
			}
		},
		methods: {

			//获取栏目
			getColumn() {
				this.dialogColumnVisible = true
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/column/list',
					params: {
						uid: localStorage.getItem('uid')
					},
				}).then((res) => {
					if (res.status == 200) {
						this.data=res.data.data
						this.data.push({
							id:0,
							columname:'首页'
						})
					} else {
						obj.$message.error(res.data.msg)
					}
				})
			},
			//选择栏目
			handleNodeClick() {
				this.selectCId = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())
				var arr = []
				for (var i = 0; i < this.$refs.tree.getCheckedNodes().length; i++) {
					arr.push(this.$refs.tree.getCheckedNodes()[i].columname)
				}
				this.form.column = arr.join(',')
			},
			//提价
			onSubmit(formName) {
				if (this.$route.query.iden == 'add') {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							var obj = this;
							obj.$http({
								method: 'post',
								url: 'api/v1/banner/add',
								data: {

									title: this.form.name,
									images: this.form.pic,
									imagesThumb: this.form.picThumb,
									column: this.selectCId.toString(),
									website: this.form.link,
									subtitle: this.form.subtitle,
									description: this.form.desc,
								},
							}).then((res) => {
								if (res.data.status == 200) {
									this.$message.success('添加成功！');
									this.$router.push({
										path: '/home/systemBanner'
									})
								} else {
									this.$message.error(res.data.message);
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});

				} else {
					this.onUpdate()
				}
			},
			//上传图片之前调取接口
			beforePic(file, fileList) {
				this.loading = true
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/banner/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
						this.loading = false
						this.form.pic = res.data.data.images
						this.form.picThumb = res.data.data.imagesThumb
						this.logoList=[]
						this.logoList.push({url:this.settings.apiBaseImg+res.data.data.imagesThumb})
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//修改
			onUpdate() {
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/banner/edit',
					data: {
						id: this.form.id,

						title: this.form.name,
						images: this.form.pic,
						imagesThumb: this.form.picThumb,
						column: this.selectCId.toString(),
						website: this.form.link,
						subtitle: this.form.subtitle,
						description: this.form.desc,
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.$message.success('修改成功！');
						this.$router.push({
							path: '/home/systemBanner'
						})
					} else {
						this.$message.error(res.data.message);
					}
				})
			},
			//关闭弹窗
			handleClose(done) {
				done();
			},
			//上传图片成功
			getLogo(file, fileList) {
				this.form.pic = file.data.images
				this.form.picThumb = file.data.imagesThumb
			},
			//删除图片
			RemoveLogo() {
				this.form.pic = ''
			},
			//图片限制
			handleLogo(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			//素材库选择图片
			selectPic(index, rows) {
				this.logoList=[]
				this.logoList.push({url:this.settings.apiBaseImg+ rows.path})
				this.form.pic = rows.path
				this.dialogVisible = false
			},

		}
	}
</script>

<style scoped="scoped">
	.title {
		margin-bottom: 40px;
	}

	/deep/ .el-input__inner {
		height: 30px;
	}

	.picTip {

		height: 16px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.5;
		margin-left: 10px;
	}

	.selectC {
		display: inline-block;

	}

	.selectC span {
		display: inline-block;
	}

	.selectC ul li {
		list-style: none;
		display: inline-block;
	}

	.select {
		font-size: 16px;
		font-weight: bold;
		display: block;
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/views/system/systemBanner/systemAdd.vue